import React from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrLink from 'client/components/SrLink/SrLink';

const SrUtilityProfitAdminProcessAddressProviderListForm = ({
  title,
  providers,
  initialState,
  onSubmit,
  onProviderMapped,
  informationalComponent,
  keyPrefix,
}) => (
  <Formik
    initialValues={initialState}
    enableReinitialize
    onSubmit={onSubmit}
    render={(formikBag) => (
      <SrBox marginTop="20px" padding="0 22px">
        <SrText font="greycliff" fontSize="21px" weight="800" lineHeight="25px" display="block">
          {title}
        </SrText>
        <SrBox padding="13px 0" display="grid" gridTemplateColumns="1fr 1fr 1fr">
          {providers.map((provider) => (
            <SrBox key={`${keyPrefix}_${provider.id}`} margin="7px 0">
              <SrText
                font="greycliff"
                fontSize="10px"
                lineHeight="17px"
                weight="700"
                display="block"
                color={provider.isMapped ? 'grey300' : provider.sourceColor}
              >
                {provider.source}
              </SrText>
              <SrText
                font="greycliff"
                fontSize="14px"
                lineHeight="17px"
                weight="700"
                paddingRight="4px"
                color={provider.isMapped ? 'grey400' : 'black'}
              >
                {provider.title}
              </SrText>
              {informationalComponent && informationalComponent(provider)}
              {/* Actions */}
              <SrBox display="flex" alignItems="center">
                {!provider.isMapped && (
                  <SrBox
                    marginRight="10px"
                    onClick={() => {
                      onProviderMapped(provider, formikBag);
                    }}
                  >
                    <SrText
                      font="greycliff"
                      fontSize="14px"
                      lineHeight="17px"
                      display="block"
                      color="blue300"
                      cursor="pointer"
                    >
                      Map provider
                    </SrText>
                  </SrBox>
                )}
                {provider.url && (
                  <SrBox marginRight="10px">
                    <SrLink target="_blank" to={provider.url}>
                      <SrText
                        font="greycliff"
                        fontSize="14px"
                        lineHeight="17px"
                        display="block"
                        color="blue300"
                      >
                        Go to site
                      </SrText>
                    </SrLink>
                  </SrBox>
                )}
                {provider.addressVerificationLink && (
                  <SrLink target="_blank" to={provider.addressVerificationLink}>
                    <SrText
                      font="greycliff"
                      fontSize="14px"
                      lineHeight="17px"
                      display="block"
                      color="blue300"
                    >
                      Verification Link
                    </SrText>
                  </SrLink>
                )}
              </SrBox>
            </SrBox>
          ))}
        </SrBox>
      </SrBox>
    )}
  />
);

SrUtilityProfitAdminProcessAddressProviderListForm.propTypes = {
  title: PropTypes.string.isRequired,
  providers: PropTypes.array.isRequired,
  initialState: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onProviderMapped: PropTypes.func.isRequired,
  informationalComponent: PropTypes.func,
  keyPrefix: PropTypes.string,
};

export default SrUtilityProfitAdminProcessAddressProviderListForm;
